import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const accordionAction = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiAccordionActions"] => ({
	root: {
		borderRadius: spacing(1),
		"&:before": undefined,
		padding: 0,
	},
});

export default accordionAction;
